import React from 'react'
import ClockIcon from '../icons/ClockIcon'
import { FormattedMessage } from 'react-intl'
import ScheduleDropdown from './ScheduleDropdown'
import { LazyDropOffSchedule } from '../../core/domain/models'
import styled from 'styled-components'

export interface IDropOffScheduleDropdown {
  schedule: LazyDropOffSchedule
  isOpenNow: boolean
}

const DropOffScheduleDropdown: React.FC<IDropOffScheduleDropdown> = ({ 
  schedule,
  isOpenNow
 }) => {

  return (
    <Container data-testid='scheduleRow-container'>
      <div>
        <ClockIcon />
        <div>
          {isOpenNow ? (
            <FormattedMessage id='DropOffScheduleDropdown.State.Open' />
          ) : (
            <FormattedMessage id='DropOffScheduleDropdown.State.Closed' />
          )}
        </div>
      </div>
      <div>
        <ScheduleDropdown
          days={Object.entries(schedule).map(([key, value]) => ({
            day: key,
            openingHours: value?.openHours || []
          }))}
          isOpenNow={isOpenNow}
        />
      </div>
    </Container>
  )
}


const Container = styled.div`
  display: flex;
  flex-direction: row;
  column-gap: 8px;
  align-items: center;
  justify-content: space-between;
  padding: 16px 0;
  font-size: ${({ theme }) => theme.size.normal};

  border-bottom: 1px solid ${({ theme }) => theme.color.lightGrey};

  & > div {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    column-gap: 8px;
  }
`


export default DropOffScheduleDropdown
